import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findSpecialities = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities${query}`,
    {
      headers,
    },
  );
};

export const findSpecialityById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities/${id}`,
    {
      headers,
    },
  );
};

export const createSpeciality = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities`,
    data,
    {
      headers,
    },
  );
};

export const updateSpeciality = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteSpeciality = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteSpecialities = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/specialities?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
